import React from 'react'



/**
 * Divider component
 * #core
 * @param {string} [height="10px"] - height of the divider
 * @param {string} [bottom] - bottom margin of the divider
 * @param {string} [borderSize="1px"] - border size of the divider
 * @param {string} [color="#c0bfbf"] - color of the divider
 * @returns {JSX.Element} - Divider component
 */
const Divider = ({height="10px", bottom, borderSize = "1px", color = "#c0bfbf"}) => {
  return (<div style={{borderBottom:`${borderSize} solid ${color}`, height, marginBottom: bottom}}/>)
}

export default Divider
